import { useCustomTranslation } from '../../../../../hooks';
import { Checkbox, Collapse } from '@nexelem/deprecated-theme';
import { ChangeEvent, useState } from 'react';
import { cn } from '@nexelem/utils';
import { WorkerAvailability, WorkerCapabilities } from '../../brigadeComponents';
import { ResourceAvailabilityMeta, TaskGanttView } from '@nexelem/graphne-api';
import { useController } from 'react-hook-form';
import { Tasks } from './Tasks';
import { WorkerAvatar } from './WorkerAvatar';

type WorkerProps = {
  data: ResourceAvailabilityMeta;
  node?: TaskGanttView;
};

export const Worker = ({ data, node }: WorkerProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const {
    field: { value: checked, onChange },
  } = useController({ name: data.resource.id.toString(), defaultValue: '' });
  const [isOpen, setOpen] = useState(false);
  const { capabilities, availabilities, tasks, name } = data.resource;

  const handleChange = (_event: ChangeEvent, checked: boolean) => {
    onChange(checked ? name : '');
  };

  return (
    <div
      className={cn(
        'rounded-xs border border-border-container bg-surface-container-lighter px-3 py-4',
        checked && 'border-border-focus-lighter bg-surface-focus-lighter',
      )}
    >
      <div className="flex items-center gap-2">
        <Checkbox checked={checked} className="shrink-0" onChange={handleChange} />
        <WorkerAvatar data={data} isOpen={isOpen} setOpen={() => setOpen(!isOpen)} />
      </div>
      <Collapse in={isOpen}>
        <div className="mt-5">
          <WorkerCapabilities capabilities={capabilities} className="mb-6" />
          <WorkerAvailability availabilities={availabilities} className="mb-6 gap-2" node={node} />
          <div className="mb-2 text-t14-sb text-text-secondary-darker">{tWrapper('tasks')}</div>
          <Tasks tasks={tasks} workerData={data.resource} />
        </div>
      </Collapse>
    </div>
  );
};
